import { render } from "./Section6Chat.vue?vue&type=template&id=41e5fbbe&ts=true"
import script from "./Section6Chat.vue?vue&type=script&lang=ts"
export * from "./Section6Chat.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__